import React from 'react';

import { Button, Icon } from '@iwoca/orion';
import { connect } from 'react-redux';

import { RootState } from '@src/reducers';
import { getSplitTestValue } from '@src/utils/selectors';

import { getCountryCode } from '../../../lendingAPI/lendingAPISelector';
import { uploadDocuments } from '../actions';
import styles from '../BusinessBankStatement/BusinessBankStatement.module.css';
import { amplitudeDocUploadClickEvent } from '../TradingHistory.amplitude';
import { DocRequirementFileTypes } from '../types';

const mapStateToProps = (state: RootState) => {
    return {
        isOpenBankingPreference: getSplitTestValue(
            state,
            'open_banking_preference'
        ),
        country: getCountryCode(state)
    };
};

const mapDispatchToProps = {
    uploadDocuments
};

const FileInput = ({
    uploadDocuments,
    documentType,
    buttonText,
    isOptional,
    size,
    isOpenBankingPreference,
    country,
    disabled = false
}: {
    uploadDocuments: (
        documents: FileList,
        documentType: DocRequirementFileTypes
    ) => void;
    documentType: DocRequirementFileTypes;
    buttonText: string;
    isOptional: boolean;
    size?: 'small' | 'medium' | 'large';
    isOpenBankingPreference: boolean;
    country: 'uk' | 'de';
    disabled?: boolean;
}) => {
    const handleSubmit = (e: React.ChangeEvent) => {
        const element = e.target as HTMLInputElement;

        uploadDocuments(element.files!, documentType);

        // this sets the value to empty string so that onChange event is triggered even if the same file is selected again
        element.value = '';
    };

    return (
        <>
            {/* TODO: review and potentially refactor the uploadBtnWrapper and revise the styling  */}
            <div
                className={`${styles.uploadBtnWrapper} ${
                    isOpenBankingPreference && country === 'uk'
                        ? styles.OBUploadBtnWrapper
                        : ''
                }`}>
                <Button
                    className={`${styles.linkAccountCTA} ${
                        isOpenBankingPreference && country === 'uk'
                            ? styles.manualUploadBtn
                            : ''
                    }`}
                    variant={isOptional ? 'tertiary' : 'secondary'}
                    size={size}
                    disabled={disabled}>
                    {buttonText}
                    <Icon className={styles.uploadIcon} icon="upload" />
                </Button>
                <input
                    id="file"
                    // TODO - use a test name without spaces
                    data-testid={`upload-input-${documentType}`}
                    multiple
                    accept=".pdf, .jpg, .png, .jpeg"
                    type="file"
                    onClick={() => {
                        amplitudeDocUploadClickEvent(documentType);
                    }}
                    hidden={true}
                    disabled={disabled}
                    onChange={(e) => handleSubmit(e)}
                />
            </div>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(FileInput);
